const SESSION_ID_KEY = 'procrastiq_content_session_id';

/** Guest content session id (sessionStorage) — used for answers and login attribution. */
export function getOrCreateSessionId(): string {
    let sid = sessionStorage.getItem(SESSION_ID_KEY);
    if (!sid) {
        sid = `guest_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
        sessionStorage.setItem(SESSION_ID_KEY, sid);
    }
    return sid;
}
